import React from 'react';
import styled from 'styled-components';

const HeroSection = styled.section`
  background-color: #121E42;
  color: white;
  padding: 80px 0;
  background: linear-gradient(135deg, #121E42 0%, #0A1535 100%);
  position: relative;
  overflow: hidden;
`;

const HeroContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 2;
`;

const HeroTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 1.5rem;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

const HeroText = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const HeroButton = styled.a`
  display: inline-block;
  background-color: #00E5FF;
  color: #121E42;
  padding: 12px 28px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #00C9E0;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 229, 255, 0.3);
    text-decoration: none;
    color: #121E42;
  }
`;

const Hero: React.FC = () => {
  return (
    <HeroSection>
      <div className="container">
        <HeroContent>
          <HeroTitle>Pós-Graduações Grupo Nobre</HeroTitle>
          <HeroText>
            Com mais de uma década de experiência, o Grupo Nobre é referência nacional em formação de especialistas na saúde. 
            Nesta página, você encontra todas as nossas pós-graduações reunidas. Escolha a sua e clique para acessar todos os detalhes.
          </HeroText>
          <HeroButton href="#cursos">Conheça nossos cursos</HeroButton>
        </HeroContent>
      </div>
    </HeroSection>
  );
};

export default Hero;